<script setup lang="ts">
import type { DropdownMenuSeparatorProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core'
import {
  DropdownMenuSeparator,
} from 'reka-ui';
import { cn } from '@/utils/shadcn';

const props = defineProps<DropdownMenuSeparatorProps & {
  class?: HTMLAttributes['class'];
}>();

const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
  <DropdownMenuSeparator
    data-slot="dropdown-menu-separator"
    v-bind="delegatedProps"
    :class="cn('border-t border-border-subtle my-1', props.class)"
  />
</template>
